import Audience from "../../components/Landing/components/Audience/Audience";
import FAQ, { faqJsonLd } from "../../components/Landing/components/FAQ/FAQ";
import Features from "../../components/Landing/components/Features/Features";
import FinalCTA from "../../components/Landing/components/FinalCTA/FinalCTA";
import Footer from "../../components/Landing/components/Footer/Footer";
import Hero from "../../components/Landing/components/Hero/Hero";
import HowItWorks from "../../components/Landing/components/HowItWorks/HowItWorks";
import Navbar from "../../components/Landing/components/Navbar/Navbar";
import PricingCallout from "../../components/Landing/components/Pricing/NewPricing/PricingCallout";
import Problem from "../../components/Landing/components/Problem/Problem";
import Solution from "../../components/Landing/components/Solution/Solution";
import Stats from "../../components/Landing/components/Stats/Stats";
import Testimonials from "../../components/Landing/components/Testimonials/Testimonials";
import { DocumentHeader } from "../../components/Seo";


export default function LandingPage() {
  return (
    <>
      <DocumentHeader jsonLd={faqJsonLd} />
      <Navbar />
      <main className="main-landing-page">
        <Hero />
        <Problem />
        <Solution />
        <Features />
        <Stats />
        <HowItWorks />
        <Audience />
        <Testimonials />
        <PricingCallout />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
